import React, { useEffect } from 'react';

const FacebookShareButtonTemplateWidget = ({ selectedLayout,isTemplateId,widgetId,facebookShareButtonTabData }) => {
    const {
        is_website_frontend,
        custom_url,
        source_type,
        layout_type,
        size_type,
    } = facebookShareButtonTabData || {};

    // Call Css
    useEffect(() => {
        // Remove other module CSS
        const oldLinks = document.querySelectorAll('link[data-dynamic-css]');
        oldLinks.forEach(link => link.remove());

        // Load CSS
        const link = document.createElement("link");
        link.rel = "stylesheet";
        link.href = `${process.env.PUBLIC_URL}/facebook-share-button/temp-css/FacebookShareButton.css`;
        if (widgetId) {
            link.setAttribute("facebook-share-button-data-dynamic-css", "facebook-share-button");
        } else {
            link.setAttribute("data-dynamic-css", "facebook-share-button");
        }
        document.head.appendChild(link);

        // Clean up on unmount
        return () => {
            const thisLink = document.querySelector('link[data-dynamic-css="facebook-share-button"]');
            if (thisLink) thisLink.remove();
        };
    }, [widgetId]);

    const isCustomURL = source_type === "Custom URL";
    const linkHref = isCustomURL ? custom_url : window.location.href;

    //Handle Share
    const handleShare = () => {
        const appId = process.env.REACT_APP_APP_ID;
        const shareUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(linkHref)}&display=popup&ref=plugin&src=like&kid_directed_site=0&app_id=${appId}`;

        window.open(
            shareUrl,
            "_blank",
            "toolbar=no,scrollbars=yes,resizable=yes,width=600,height=400"
        );
    };

    return (
        <>
            <div className={`upgadeify facebook_share_button facebook-share-button-temp ${is_website_frontend}`}>
                <div className={`facebook-share-button ${size_type}`}>
                        {layout_type === "Box count" && (
                        <>
                            <span className='facebook-share-no'>15K</span>
                            <button className='share-button' onClick={handleShare}> <svg version="1.1" id="svg-facebook" x="0px" y="0px" width="24px" height="24px" viewBox="0 0 24 24" className="eapps-social-icons-item-icon"><g><path fill="#3E68C0" d="M5.677,12.998V8.123h3.575V6.224C9.252,2.949,11.712,0,14.736,0h3.94v4.874h-3.94c-0.432,0-0.934,0.524-0.934,1.308v1.942h4.874v4.874h-4.874V24H9.252V12.998H5.677z"></path></g></svg><span>Share</span></button>
                        </>
                        )}

                        {layout_type === "Button count" && (
                        <>
                            <button className='share-button' onClick={handleShare}> <svg version="1.1" id="svg-facebook" x="0px" y="0px" width="24px" height="24px" viewBox="0 0 24 24" className="eapps-social-icons-item-icon"><g><path fill="#3E68C0" d="M5.677,12.998V8.123h3.575V6.224C9.252,2.949,11.712,0,14.736,0h3.94v4.874h-3.94c-0.432,0-0.934,0.524-0.934,1.308v1.942h4.874v4.874h-4.874V24H9.252V12.998H5.677z"></path></g></svg><span>Share 15K</span></button>
                        </>
                        )}

                        {layout_type === "Button" && (
                        <>
                            <button className='share-button' onClick={handleShare}> <svg version="1.1" id="svg-facebook" x="0px" y="0px" width="24px" height="24px" viewBox="0 0 24 24" className="eapps-social-icons-item-icon"><g><path fill="#3E68C0" d="M5.677,12.998V8.123h3.575V6.224C9.252,2.949,11.712,0,14.736,0h3.94v4.874h-3.94c-0.432,0-0.934,0.524-0.934,1.308v1.942h4.874v4.874h-4.874V24H9.252V12.998H5.677z"></path></g></svg><span>Share</span></button>
                        </>
                        )}
                </div>
            </div>

        </>
    );
};

export default FacebookShareButtonTemplateWidget;
